type ForecastPositionViewFlags = {
  enablePositionBackedVacancies?: boolean | null;
  enableForecastPositionView?: boolean | null;
};

/** Position view needs seats *and* its own rollout flag (default off). */
export const isForecastPositionViewEnabled = ({
  enablePositionBackedVacancies,
  enableForecastPositionView,
}: ForecastPositionViewFlags = {}): boolean =>
  Boolean(enablePositionBackedVacancies && enableForecastPositionView);
